const isMobileIonic = () => {
    if (window.Capacitor !== undefined) {
        return true;
    }else{
        return false
    }
};

const getCookieOptions = () => {
    const secure = isMobileIonic() ? '' : 'Secure;';
    return `path=/;${secure}`;
};

export const deleteCookie = (cname) => {
    const d = new Date(0); // Jan 1, 1970
    document.cookie = `${cname}=;expires=${d.toUTCString()};${getCookieOptions()}`;
};

export const setCookie = (cname, cvalue, exMins = 30) => {
    const now = new Date();
    now.setTime(now.getTime() + exMins * 60 * 1000);
    const expires = `expires=${now.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};${getCookieOptions()}`;
};

export const getCookie = (cname) => {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length);
    }
    return "";
};

export const updateCookie = (name, val, exMins = 30) => {
    const now = new Date();
    now.setTime(now.getTime() + exMins * 60 * 1000);
    const expires = `expires=${now.toUTCString()}`;
    document.cookie = `${name}=${val};${expires};${getCookieOptions()}`;
};

export const readCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

export const updateAllCookiesExpiry = (exMins = 30) => {
    const now = new Date();
    now.setTime(now.getTime() + exMins * 60 * 1000);
    const expires = `expires=${now.toUTCString()}`;
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        const value = eqPos > -1 ? cookie.substr(eqPos + 1).trim() : "";
        document.cookie = `${name}=${value};${expires};${getCookieOptions()}`;
    }
};

export const deleteAllCookies = () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        if (name !== "sessionId") {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;${getCookieOptions()}`;
        }
    }
};
